var map = {
	"./CLIENT_GAME.gql": "ed50",
	"./CLIENT_GAME_BY.gql": "02cf",
	"./CLIENT_GAME_STEP.gql": "0838",
	"./CLIENT_GAME_STEP_FORM.gql": "8bf8",
	"./CLIENT_MEDIA_INDEX.gql": "8893",
	"./CLIENT_MEDIA_INDEX_NO_URL.gql": "e479",
	"./CLIENT_SECTION_BY.gql": "b7bb",
	"./CLIENT_TUTORIAL_INDEX.gql": "443a",
	"./CLIENT_USER_CHALLENGE.gql": "ceba",
	"./CURRENT_USER.gql": "bbe4",
	"./LEADERBOARD.gql": "1df7",
	"./SCHEMA.gql": "2f3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "085a";